module.exports = __webpack_public_path__ + "img/français.8315ea2a.svg";